import { render } from "./MyPositions.vue?vue&type=template&id=ff517958"
import script from "./MyPositions.vue?vue&type=script&lang=js"
export * from "./MyPositions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__